import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { Company, User } from '../models/user';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['../login/login.component.scss'],
})
export class PasswordComponent implements OnInit {
  passwordForm: FormGroup;
  company: string = ""
  username: string = ""
  message:string ="";
  constructor(private router: Router, private route: ActivatedRoute, private authService: AuthenticationService, private fb: FormBuilder, private modal: ModalController) { }

  ngOnInit() {
    this.username = this.route.snapshot.paramMap.get("username");
    this.company = this.authService.getSelectedCompany();

    console.log(this.company)
    if (this.company) {
      this.passwordForm = this.fb.group({
        username: { disabled: true },
        password: ['', Validators.required],
        company: { disabled: true }
      })



    } else {
      this.router.navigate(['/auth']);
    }
  }

  login() {
  if (!this.username) {
    this.router.navigate(['/auth']);
    return;
  }

  this.passwordForm.get('username').setValue(this.username);
  this.passwordForm.get('company').setValue(this.company);
   this.authService.login(this.passwordForm.getRawValue() as User).subscribe({
    next:(data) =>{
      if (data.access) {
      // Set session first
      this.authService.setSession(data);

      // Now retrieve values from localStorage after setSession
      const tr069User = {
        username: localStorage.getItem('username') || this.username,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        security_token: localStorage.getItem('security_token') || '',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        company_id: localStorage.getItem('company') || this.company,
        sn: localStorage.getItem('sn') || '48575443AF08338C'
      };

      // Call loginTr069 with the constructed user
      this.authService.loginTr069(tr069User).subscribe({
        next: (tr069Data) => {
          console.log('TR-069 login successful:', tr069Data);
          this.router.navigate(['/client/dashboard']);
        },
        error: (err) => {
          console.error('TR-069 login failed:', err);
          this.router.navigate(['/client/dashboard']);
        }
      });
    } else {
      // Handle invalid access token case if needed
    }
    },
    error:(err)=>{
      if (Array.isArray(err?.error?.detail) && err.error.detail.length > 0) {
          this.message  = err.error.detail[0]; // Get first error message
  } 
  // Optional: handle case where detail is a string (for compatibility)
  else if (typeof err?.error?.detail === 'string') {
 this.message  = err.error.detail;
  }


    }
   })






}


  async recoverAccount() {
    this.message="";
    const modal = await this.modal.create({
      component: ConfirmDialogComponent,

    })
    modal.present();
    const { data, role } = await modal.onWillDismiss();
    if (role == 'confirm') {
     this.authService.recoverAccount({ username: this.username, company: this.company }).subscribe({
  next: (data) => {
    console.log(data,"======")
    if (data['message']) {
      this.message = data['message'];
      this.authService.presentToast("bottom", this.message);
    }
  },
  error: (err) => {
    console.log(err,"====")
    const errorMessage = err?.error?.detail || 'An unexpected error occurred';
    this.message = errorMessage;
    this.authService.presentToast("bottom", this.message);
  }
});

  }


}

}